import React, { useCallback, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';
import { Grid, Link, units } from '@hbf/dsl';
import { PlaceFilter } from 'ha/components/Filters/PlaceFilter';
import { useSearchBarContext } from 'ha/modules/SearchBar';
import { track } from '@hbf/analytics';

import { SearchFiltersContext } from '../SearchFiltersContext';

const useStyles = makeStyles()(theme => ({
  link: {
    fontSize: units.rem(1),
    marginTop: units.rem(0.5),
    padding: units.yx(0.5, 0.8),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(0.5),
  },
}));

export const SearchLocationChangeCity: React.FC = () => {
  const { T } = useIntl();
  const { classes } = useStyles();
  const [canChangeCity, setCanChangeCity] = useState(false);
  const { initialSuggestions } = useSearchBarContext();
  const { localState, onChangePlace } = React.useContext(SearchFiltersContext);

  const displayCityFilterHandler = useCallback(() => {
    setCanChangeCity(true);
    track('clicked change city');
  }, []);

  const lostFocusHandler = useCallback(() => setCanChangeCity(false), []);

  const changeCityHandler = useCallback(
    (value: string) => {
      setCanChangeCity(false);
      onChangePlace(value);
    },
    [onChangePlace],
  );

  if (!canChangeCity) {
    return (
      <Grid container item>
        <Link
          to="#"
          className={classes.link}
          onClick={displayCityFilterHandler}
        >
          {T('search_page.change_city')}
        </Link>
      </Grid>
    );
  }

  return (
    <div onBlur={lostFocusHandler}>
      <PlaceFilter
        {...{
          value: localState.place,
          onChange: changeCityHandler,
          initialItems: initialSuggestions,
          changeOnlyOnSelect: true,
          hasDeleteButton: true,
        }}
      />
    </div>
  );
};
